// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"7ccbf240","249":"b211a4ad","467":"9fa7809f","483":"4b777fc4","549":"51bdf6d9","694":"07426114","716":"baf40fd9","872":"6d0412d7","908":"7ac6f8db","914":"984ec4d8","938":"5bd9921a"}[chunkId] + ".chunk.js";
};